var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#ff0",
  className: "square_svg__block square_svg__shrink-0",
  viewBox: "0 0 1408 1535.72",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 0h1408v1535.72H0V0Zm150 150h1108v1235.72H150V150Z",
  clipRule: "evenodd"
})));
SvgSquare.viewBox = '0 0 1408 1535.72';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare);
export default ForwardRef;